import React, { PureComponent } from 'react';
import injectSheet from 'react-jss'
import { connect } from 'react-redux'
import CentredContentContainer from '../Widgets/CentredContentContainer'
import SearchResultItem from './SearchResultItem'
import {searchQueryChanged, loadMoreSearchResults, toggleSearchDialog} from '../../actions'
import {
    getSearchLoading,
    getSearchQuery,
    getSearchResults,
    getTrending,
    hasMoreSearchPages,
    getTotalSearchResults,
} from "../../selectors"
import {formatSummary} from "../../utils/search"
import SearchFilter from './SearchFilter'
import {StyledInifinateScrollWaypoint} from '../InfiniteScrollWaypoint'

class SearchList extends PureComponent {

    _getSummary = () => {
        const {query, loading, totalResults} = this.props;
        return formatSummary(query, loading, totalResults);
    }

    render() {
        const {classes, results, loading, hasMore, trending, handleLoadMore} = this.props;

        return <div>
            <section className={classes.searchFilterContainer}>
                <CentredContentContainer size="huge">
                    <SearchFilter />
                </CentredContentContainer>
            </section>

            <section>
                <CentredContentContainer size="huge" className={classes.resultContainer}>
                    {results && results.map((result, i) => <SearchResultItem key={result.slug} item={result} trending={trending} /> )}
                </CentredContentContainer>
            </section>
            {results && results.length > 0 && <StyledInifinateScrollWaypoint isLoading={loading} hasMore={hasMore} handleLoadMore={handleLoadMore} />}
         </div>
    }
}

const mapStateToProps = (state) => {
    return {
        loading: getSearchLoading(state),
        query: getSearchQuery(state),
        results: getSearchResults(state),
        trending: getTrending(state),
        hasMore: hasMoreSearchPages(state),
        totalResults: getTotalSearchResults(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        handleSearch: ( query ) => {
            dispatch(searchQueryChanged(query))
        },
        handleCloseDialog: () => {
            dispatch(toggleSearchDialog())
        },
        handleLoadMore: () => {
            dispatch(loadMoreSearchResults())
        }
    }
}

export default injectSheet((theme) => ({
    searchFilterContainer: {
        backgroundColor: theme.colors.info,
        marginLeft: 0,
        marginRight: 0,
        padding: `${theme.spacing.small} 0`,
        [theme.breakpoint('mobile')]: {
            padding: `${theme.spacing.normal} 0`,
        },
        [theme.breakpoint('tablet')]: {
            padding: `${theme.spacing.large} 0`,
        }
    },
    resultContainer: {
        marginLeft: '-10px',
        marginRight: '-10px',
        minHeight: 200,
    },
}))( connect(mapStateToProps, mapDispatchToProps)(SearchList) );



// WEBPACK FOOTER //
// ./src/components/Search/SearchList.js